import React, { useState, useEffect, useCallback, useRef } from "react";

import { toast } from "react-toastify";
import moment from 'moment';

import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

import PaginationV2 from "@app/components/Pagination/V2";

LoadingOverlay.propTypes = undefined;

const defaultColDef = {
    editable: false,
    sortable: false,
    filter: false,
    resizable: true,
    cellClass: "text-center",
    headerClass: "bg-dark text-light",
    suppressMovable: true,
};

const ManageWithdrawal = ({}) => {
	const LIMIT_PER_PAGE = 15;
    const [loadingData, setLoadingData] = useState(false);
    const [pageInfo, setPageInfo] = useState({ page: 0, total: 0 });
    const [searchParam, setSearchParam] = useState({
        searchApp: "",
        searchType: "user_id",
        searchKey: "",
    });
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        window.executeWithdrawal = executeWithdrawal;
        window.undoWithdrawal = undoWithdrawal;
    }, []);

    useEffect(() => {
        return () => {};
    }, [tableData, loadingData, searchParam]);
	

    const listColumn = [
        {
            headerName: "No",
			width: 75,
			cellClass: "text-center",
            valueGetter: `(${pageInfo.page} * ${LIMIT_PER_PAGE}) + node.rowIndex + 1`,
        },
        {
            headerName: "ID",
            field: "id",
            hide: true,
        },
        {
            headerName: "아이디",
            field: "userId",
            width: 100,
            cellClass: "text-center",
        },
        {
            headerName: "휴대전화번호",
            field: "mobile",
        },
        {
            headerName: "이메일",
            field: "email",
        },
        {
            headerName: "가입 서비스",
            field: "app",
            cellRenderer: (params) => {
                if (params.value == "flyeng_home") {
                    return "플라잉 홈스쿨링";
                } else if (params.value == "tomoplay") {
                    return "토모플레이";
                } else if (params.value == "tomobooks") {
                    return "별별책방(부모님)";
                } else if (params.value == "jelliing_home") {
                    return "젤링 홈스쿨링";
                }
                return "-";
            },
        },
        {
            headerName: "회원 탈퇴일",
            field: "requestDate",
            cellClass: "text-left",
        },
        {
            headerName: "개인정보 삭제 예정일",
            field: "withdrawalDate",
            cellClass: "text-left",
            cellRenderer: (param) => {
                if (param.data.executedDate) {
                    return '' + moment(param.data.withdrawalDate).add(1, 'day').format('YYYY-MM-DD') + `<span class="badge badge-danger ml-2" style="display: inline-block;">삭제됨</span>`;
                } else {
                    return moment(param.data.withdrawalDate).add(1, 'day').format('YYYY-MM-DD');
                }
            },
        },
        {
            headerName: "개인정보 삭제 취소",
            field: "id",
            cellClass: "text-center",
            cellRenderer: (param) => {
                if (param.data.executedDate) {
                    return '';
                } else {
                    return `<button class="btn btn-info btn-sm " style='padding : 2px 5px;' onClick="undoWithdrawal(${param.data.id}, '${param.data.userId}')">복원</button>`;
                }
            },
        },
    ];

    const getData = (page) => {
        setLoadingData(true);
		console.debug(searchParam);
        axios({
            method: "post",
            url: `/api/subscriber/withdrawal/list`,
            data: { page: page, limit: LIMIT_PER_PAGE, ...searchParam },
        })
            .then((res) => {
                const result = res.data;
                setLoadingData(false);
                setPageInfo({ page: page, total: result.total });
                setTableData(result.list);
            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const onGridReady = useCallback((params) => {
        getData(0);
    }, []);

    const onRowDataChanged = (params) => {
        params.api.sizeColumnsToFit();
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };

    const onSearch = () => {
        onPaging(0);
    };

    const onPaging = (page) => {
        getData(page);
    };

    const executeWithdrawal = (id, userId) => {
		if(window.confirm(`해당 계정 정보를 삭제하시겠습니까?\n(* 삭제 시 다시 복원할 수 없습니다.)\n계정: ${userId}`)) {
			setLoadingData(true);
			axios({
				method: "delete",
				url: `/api/subscriber/withdrawal/${id}/execute`,
			})
				.then((res) => {
					getData(0);
				})
				.catch((error) => {
					console.log(error);
					setLoadingData(false);
					console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
				});
		}
    };

    const undoWithdrawal = (id, userId) => {
		if(window.confirm(`해당 계정 정보를 복원하시겠습니까?\n계정: ${userId}`)) {
			setLoadingData(true);
			axios({
				method: "post",
				url: `/api/subscriber/withdrawal/${id}/undo`,
			})
				.then((res) => {
					const result = res.data;
					if(result.code == 200) {
						toast.success('계정 정보를 복원하였습니다.');
						getData(0);
					} else {
						setLoadingData(false);
						toast.error('계정 정보 복원 중 오류가 발생하였습니다.' + (result.msg ? '<br/>' + result.msg : ''));
					}
				})
				.catch((error) => {
					console.log(error);
					setLoadingData(false);
					console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
				});
		}
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">회원 탈퇴 및 개인정보 삭제</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <LoadingOverlay active={loadingData} spinner>
                        <div className="row align-items-end">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                                <h5 className="mb-0" style={{ alignSelf: "end" }}>
                                    <span>
                                        {tableData && tableData.length > 0 ? tableData.length.toLocaleString() : "0"} / {pageInfo.total.toLocaleString()}
                                    </span>
                                </h5>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2">
                                <InputGroup className="input-group my-group">
                                    <select
                                        className="form-control"
                                        value={searchParam.searchApp}
                                        onChange={(e) => {
                                            const param = { ...searchParam };
                                            param.searchApp = e.target.value;
                                            setSearchParam(param);
                                        }}
                                        style={{height: "calc(2.25rem + 7px)"}}
                                    >
                                        <option value="">서비스 전체</option>
                                        <option value="flyeng_home">플라잉 홈스쿨링</option>
                                        <option value="tomoplay">토모플레이</option>
                                        <option value="tomobooks">별별책방(부모님)</option>
                                    </select>
                                    <select
                                        className="form-control"
                                        value={searchParam.searhType}
                                        onChange={(e) => {
                                            const param = { ...searchParam };
                                            param.searchType = e.target.value;
                                            setSearchParam(param);
                                        }}
                                        style={{height: "calc(2.25rem + 7px)"}}
                                    >
                                        <option value="user_id">아이디</option>
                                        <option value="mobile">휴대전화 번호</option>
                                        <option value="email">이메일</option>
                                    </select>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={searchParam.searhKey}
                                        placeholder="검색"
                                        onChange={(e) => {
                                            const param = { ...searchParam };
                                            param.searchKey = e.target.value;
                                            setSearchParam(param);
                                        }}
                                        onKeyPress={handleKeyPress}
                                    />
                                    <InputGroup.Append>
                                        <Button className="btn btn-primary" onClick={onSearch}>
                                            검색
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col ag-theme-balham" style={{ height: "600px" }}>
                                <AgGridReact
                                    onGridReady={onGridReady}
                                    defaultColDef={defaultColDef}
                                    columnDefs={listColumn}
                                    rowData={tableData}
                                    onRowDataChanged={onRowDataChanged}
                                    rowHeight={40}
                                    enableCellTextSelection={true}
                                    ensureDomOrder={true}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                                <PaginationV2 perPage={LIMIT_PER_PAGE} maxShowPage={10} currentPage={Number(pageInfo.page)} total={Number(pageInfo.total)} callback={onPaging} disabled={loadingData} />
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"></div>
                        </div>
                    </LoadingOverlay>
                </div>
            </div>
        </div>
    );
};

export { ManageWithdrawal as default };
